<template>
  <div>
    <div v-if="$route.name === 'setup'">      
      <h3 class="mt-10 mb-6 relative font-medium pr-12 text-3xl inline-block"><span class="text-primary font-semibold">Great!</span> Now let's hear about your business.<img class="absolute top-0 right-0 mt-1 -mr-10 ml-64 w-8 md:w-12" src="@/assets/images/smiley.png"/></h3>
      <p class="mb-2 text-lg text-dark">Enter your business information.</p>
      <p class="mt-4">If your business has multiple locations or departments, enter the details of your first one — you can add the others as separate spaces later.</p>
    </div>
    <div v-else>
      <div v-if="$route.name !== 'addnewclient'">
      <h3 class="mt-10 mb-6 relative font-medium pr-12 text-3xl md:text-4xl inline-block">Add new space</h3>
      <p class="mt-2 text-lg">Enter the details for the new space — a separate business, department or location with its own survey and collaborators.</p>
      </div>
      <div v-else>
        <h3 class="mt-10 mb-6 relative font-medium pr-12 text-3xl md:text-4xl inline-block">Add client</h3>
        <p class="mt-2 text-lg font-medium">This will create a new feedback link account for your client business.</p>
        <p class="mt-2">You will be able to manage the client's account from your dashboard, or invite them to collaborate on the account.</p>
        <vs-divider/>
        <vs-input
            v-model="clientBrandName"
            label="Client Name"
            placeholder="e.g. Hopkins Law"
            class="w-full"
            />
        <p class="text-light text-sm mt-2">This is to identify this account and will only be seen by you.</p>
        <vs-divider/>
        <p class="mt-2 font-medium text-lg">Business details</p>
        <p class="mt-2">If your client has multiple locations or departments, enter the details of the first one — the others can be added as separate spaces later.</p>
      </div>
    </div>
    <vs-input
        v-model="businessName"
        label="Business Name"
        placeholder="e.g. Hopkins Law New York"
        class="mt-4 w-full"
      />
    <p class="text-light text-sm mt-2">Don't include the 'LLC' or 'Inc.' here.</p>
    <span class="mt-2 text-danger" v-if="bNameMsg"> {{ bNameMsg }}</span>
    <vs-input
        v-model="businessEmail"
        label="Business email address"
        placeholder="your@email.com"
        class="mt-6 w-full" />
    <span class="mt-2 text-danger" v-if="bEmailMsg"> {{ bEmailMsg }}</span>
    <div class="optionalwrap">
    <vs-input
      v-model="businessContactLocalNumber"
      label="Business contact number"
      placeholder="e.g. 555-372-4311"
      class="mt-6 w-full"/>
      <span class="mt-2 text-danger" v-if="bNumberMsg"> {{ bNumberMsg }}</span>
    </div>
    <div class="optionalwrap mb-6">
    <vs-input
      v-model="businessWebsite"
      label="Business Website"
      placeholder="www.website.com"
      class="mt-8 w-full"/>
    <span class="text-danger" v-if="bWebsiteMsg"> {{ bWebsiteMsg }}</span>
    </div>

    <div v-if="$route.name !== 'addnew'"> 
      <label class="vs-input--label">Language</label>
      <v-select placeholder="Select language..." class="w-full bg-white mb-0" style="z-index: 10000;" size="large" :searchable="false" :clearable="false" :options="languagePacksLocal" label="name" :reduce="pack => pack.i" v-model="selectedLanguagePack" />
      <span class="text-light">Language not here<vx-tooltip class="inline-block ml-1 relative" style="top:0.4rem;" position="left" text="If your language isn't yet supported, you can create your own translation in your dashboard. Please let us know which language we're missing!">
              <small class="flex cursor-pointer">
                <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-light"></feather-icon>
              </small>
            </vx-tooltip></span>
    </div>
    
      <div class="overflow-visible h-32">
        <p class="text-primary clear-both text-lg my-8 font-medium" v-if="message">{{ message }}</p>
        <vs-button size="large" class="float-right my-6 w-full lg:w-48 font-semibold py-6 text-base lg:text-xl lg:w-64 pmybtnshdw" @click="nextStep"  icon-pack="feather" icon="icon-chevron-right" icon-after >{{ $route.name !== 'addnew' ? 'Appearance' : 'Next' }} </vs-button>
      </div>
  </div>
</template>


<script>

    /*

    UNDER FIRST, TELL US ABOUT YOUR...


      1. Copy signup store, make provisioning for new URLs
      2. Copy setStateFunction
      3. Connect for all steps 1 - 3
          - validation and usr feedback
          - chosen links checkup
          - logo upload
          - bgcolor choosing
          - recoding of "i dont have logo"
      4. Copy paste signup function

    */


    import store from '../../../store/store'
    import signupComputedVmodel from '../common/setSignupComputedVmodel'
    import vSelect from 'vue-select'

    export default {
      data() {
        return {
          message: false,
          bNumberMsg: false,
          bNameMsg: false,
          bEmailMsg: false,
          bContactMsg: false,
          bWebsiteMsg: false,
          bNameMax: 40,
          bEmailMax: 40,
          bWebsiteMax: 45,
          bContactMax: 14,
          tos: true,
          selectedLanguagePack: 0,
          languagePacksLocal: []
        }
      },
      components: {
        'v-select': vSelect
      },
      computed: {
        clientBrandName: signupComputedVmodel(store, ['agencyInfo', 'clientBrandName']),
        businessWebsite: signupComputedVmodel(store, ['businessInfo', 'webAddress']),
        businessEmail: signupComputedVmodel(store, ['businessInfo', 'businessEmail']),
        businessName: signupComputedVmodel(store, ['businessInfo', 'businessName']),
        signupLanguageChoice: signupComputedVmodel(store, ['signupLanguageChoice']),
        businessContactLocalNumber: signupComputedVmodel(store, ['businessInfo', 'businessContact', 'localNumber']),
        languagePacks() {
          return this.$store.getters['dash/officialTranslations']
        }
      },
      watch: {
        selectedLanguagePack(v) {
          this.signupLanguageChoice = this.languagePacksLocal[v].language
        },      
        languagePacks(v) {
          if (v) {
            this.languagePacksLocal = [...v]
            //assign an index to each language pack
            this.languagePacksLocal.forEach((item, i) => {
              if (item.language === 'en') {
                this.selectedLanguagePack = i
              }
              item.i = i
            })
          }
        },
        businessWebsite (v){
          this.message = ""
          if (v.length > this.bNameMax) {
            this.bWebsiteMsg = 'Website address can\'t be more than ' + this.bNameMax + 'characters.'
          } else {
            this.bWebsiteMsg = false
          }
        },
        businessEmail (v){
          this.message = ""
          if (v.length > this.bEmailMax) {
            this.bEmailMsg = 'Email address can\'t be more than ' + this.bEmailMax + ' characters.'
          } else {
            this.bEmailMsg = false
          }
        },
        businessName (v){
          this.message = ""
          if (v.length > this.bNameMax) {
            this.bNameMsg = 'Business name can\'t be more than ' + this.bNameMax + ' characters.'
          } else {
            this.bNameMsg = false
          }
        },
        businessContactLocalNumber (v){
          this.message = ""
          if (v.length > this.bContactMax) {
            this.bNumberMsg = 'Contact number can\'t be more than ' + this.bContactMax + ' characters.'
          } else {
            this.bNumberMsg = false
          }
        },
        tos () {
          this.bWebsiteMsg = false
        }
      },
      methods: {
        nextStep() {
          if (this.formReady()) {
            this.$emit('next')
            this.scrollToTop()
          }
        },
        formReady() {

          let busEmail = this.businessEmail
          let busName = this.businessName
          let businessContact = this.businessContactLocalNumber
          let businessWebsite = this.businessWebsite

          //noconsoleconsole.log(this.bContactMsg)


          if (this.$route.name === 'addnewclient' && this.clientBrandName.trim() === '' ) {
            this.message = "We need a name for your new client."
            return false
          }

          if (this.bNameMsg || this.bNumberMsg || this.bEmailMsg || this.bWebsiteMsg) {
            this.message = "Check the length of all your inputs, one or more fields are too long."
            return false
          }

          if (!(busName.length > 0)) {
            this.message = 'We need your business name.'
            return false
          }

          if (busEmail.length === 0) {
            this.message = 'We need your business email address.'
            return false
          }
          if (!this.validateEmail(busEmail)) {
            this.message = 'Please enter a valid business email address.'
            return false
          }
          if (businessContact.length > 0) {
            if (businessContact.match(/[A-Z|a-z|ü|é]/i) || businessContact.length < 5) {
              this.message = 'Please enter a valid business contact number.'
              return false
            }
          }
          if (businessWebsite.length > 0) {
            if (!this.validURL(businessWebsite)) {
              this.message = 'Please enter a valid business website address.'
              return false
            }
          }

          if (!this.tos) {
              this.message = 'You need to accept our terms of use to continue.'
              return false
          }

          return true
        }
      },
      created() {        
        if (this.$store.state.dash.viewState.officalLanguagesLoaded) {
          this.languagePacksLocal = [...this.$store.state.dash.officialLanguagePacks]
          this.languagePacksLocal.forEach((item, i) => {
              if (item.language === 'en') {
                this.selectedLanguagePack = i
              }
              item.i = i
          })
        }      
      }
  }

</script>
